import template from './userInfo.html';
import './userInfo.scss';

export const CheckoutUserInfoModule =
    angular.module('app.components.checkout.components.checkoutUserInfo', [])
        .component('checkoutUserInfo', {
            template,
            bindings: {
                user: '<',
                showContainer: '<',
                onPaymentMethodSelected: '<',
                purchaseComplete: '<',
                onToggleEditMode: '<'
            }
        }).name;



// WEBPACK FOOTER //
// ./src/app/components/checkout/components/userInfo/userInfo.js